import { createContext } from 'react';

export type RefundTransactionCtx = {
  showRefundTransactionConfirmAlert: boolean;
  showRefundTransactionErrorAlert: boolean;
  sendRefundTransactionError: string;
};

const RefundTransactionDialogueContext = createContext<RefundTransactionCtx>({
  showRefundTransactionConfirmAlert: false,
  showRefundTransactionErrorAlert: false,
  sendRefundTransactionError: '',
});

export default RefundTransactionDialogueContext;